// extracted by mini-css-extract-plugin
module.exports = {"form":"RefinementPrice_form__955d7","box":"RefinementPrice_box__rEH_K","input":"RefinementPrice_input__PobcZ","dash":"RefinementPrice_dash__S0C2y"};